<div
	class="relative w-full px-6 py-10 bg-white sm:!w-112 sm:p-14 rounded-lg shadow-lg mx-auto"
>
	<!-- title & close option-->
	<div class="flex items-center justify-between mb-4">
		<h2 class="text-2xl font-bold">Report Review</h2>
		<uc-close-modal />
	</div>
	<!-- feedback -->
	@if (formSuccess) {
		<uc-report-feedback [error]="formError" [message]="reportFeedback" />
	}
	@if (!formSuccess) {
		<form class="grid gap-6" [formGroup]="reportForm" (ngSubmit)="onSubmitReport()">
			<uc-input-field
				formControlName="email"
				inputType="email"
				controlName="email"
				placeholder="Email Address"
				autocomplete="email"
				labelText="Email Address"
				[formSubmitted]="formSubmitted"
			/>
			<div class="relative">
				<div
					class="p-4 border rounded-md shadow-sm h-52 input-focus-within"
					[ngClass]="{
						'border-red-500 focus-within:ring-red-600 focus-within:border-red-600':
							formSubmitted && reportForm.controls['message'].errors,
						'border-gray-300 focus-within:ring-gray-400':
							!formSubmitted && !reportForm.controls['message'].errors,
					}"
				>
					<label
						for="message"
						class="absolute top-0 inline-block px-1 -mt-px text-xs font-medium text-gray-700 bg-white left-2"
						ngClass="{{ reportForm.value.message ? 'show-label' : 'label' }}"
					>
						Report
					</label>
					<textarea
						class="w-full h-full border-0 outline-none resize-none focus:ring-0"
						id="message"
						name="message"
						formControlName="message"
						placeholder="Please enter why you are reporting this review here"
					></textarea>
				</div>
				<!-- Errors -->
				<uc-form-error
					fieldError="Please enter a reason."
					[formError]="
						formSubmitted &&
						reportForm.controls['message'].hasError('required')
					"
				/>
			</div>
			<!-- send message -->
			<button
				class="flex justify-center w-full py-2 mx-auto text-base border border-gray-200 rounded-lg red-button"
			>
				Submit report
			</button>
		</form>
	}
</div>
